import type { CreateFieldOptions } from '@cims-online/shared'
import { Form } from 'antd'
import HelpIcon from 'components/HelpIcon'

type CreationFormItemProps = {
  control: React.ReactNode
  error: string | undefined
  field: CreateFieldOptions
}

/** Keeps shared creation-field presentation independent of its input control. */
function CreationFormItem({ control, error, field }: CreationFormItemProps) {
  const hidden = field.readOnly?.hideFieldValue === true

  return (
    <Form.Item
      colon={!!field.name}
      help={error}
      hidden={hidden}
      label={<HelpIcon text={field.tooltip}>{field.name}</HelpIcon>}
      name={field.id}
      required={field.required !== false}
      validateStatus={error ? 'error' : undefined}
    >
      {hidden ? <HiddenFormValue /> : control}
    </Form.Item>
  )
}

/** Registers a hidden form value without mounting an invisible input control. */
function HiddenFormValue() {
  return null
}

export default CreationFormItem
